// Which of an account's snapshots saw a website, read with whichever Supabase
// client is passed in ("db"), so tests can use fakeSupabase.
// Matches appearances.business_domain exactly (it has an index), always
// within the one account. A very common website (a directory) can have
// thousands of appearances, so they're read a page at a time; a database
// function returning just the snapshot ids would make this one quick query.

// Supabase sends at most 1,000 rows per request.
const PAGE_SIZE = 1000;

// domain: already cleaned ("acme.co.uk"). Returns the job ids, no repeats.
export async function findJobIdsForWebsite(db, agencyId, domain) {
  if (!agencyId || !domain) return [];
  const ids = new Set();
  for (let from = 0; ; from += PAGE_SIZE) {
    const { data, error } = await db
      .from("appearances")
      .select("job_id")
      .eq("agency_id", agencyId)
      .eq("business_domain", domain)
      .order("id", { ascending: true })
      .range(from, from + PAGE_SIZE - 1);
    if (error) {
      console.error("findJobIdsForWebsite", error);
      break;
    }
    if (!data || data.length === 0) break;
    for (const row of data) ids.add(row.job_id);
    if (data.length < PAGE_SIZE) break;
  }
  return [...ids];
}
